const mainSearchForm = {
  flights: "Flüge", // translated
  tours: "Touren", // translated
  hotel: "Hotel", // translated
  hotels: "Hotels", // translated
  services: "Dienstleistungen", // translated
  search: "SUCHE", // translated
  destination: "Ziel", // translated
  includedServices: "Inklusivleistungen", // translated
  packageDuration: "Paketdauer", // translated
  checkInOut: "Ein-/Auschecken", // translated
  guests: "Gäste", // translated
  adults: "Erwachsene", // translated
  children: "Kinder", // translated
  child: "Kind", // translated
  age: "Alter", // translated
  yearsOld: "Jahre alt", // translated
  rooms: "Räume", // translated
  close: "Schließen", // translated
  searchType: "Suchtyp", // translated
  accommodation: "Unterkunft", // translated
  transfers: "Überweisungen", // translated
  toursExperiences: "Touren/Erlebnisse", // translated
  nights: "Nächte", // translated
  days: "Tage", // translated
  packageType: "Pakettyp", // translated
  tourType: "Tourtyp", // translated
  packages: "Pakete", // translated
  cars: "Autos", // translated
  cruises: "Kreuzfahrten", // translated
  passengers: "Passagiere", // translated
  infantsInSeat: "Kleinkinder im Sitz", // translated
  airport: "Flughafen", // translated
  partying: "Party machen", // translated
  roundTrip: "Rundfahrt", // translated
  origin: "Herkunft", // translated
  thingsToDo: "Dinge die zu tun sind", // translated
  dream_packages: "Traumpakete", // translated
  departureReturn: "Abreise- und Rückreisetermine", // translated
  isRoundTrip: "Ist Hin- und Rückfahrt", // translated
  infantsOnLap: "Kleinkinder auf dem Schoß", // translated
};

export default mainSearchForm;
